import styled from 'styled-components'
import { Badge } from '@77sol-ui/atoms'

export const Root = styled(Badge)`
  font-family: Nexa, sans-serif;
  white-space: nowrap;
`
